import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { Middleware } from '@reduxjs/toolkit'

import { removeToken } from '../services/services.helpers'

const publicPages = [
  '/login',
  '/booking',
  '/confirmation',
  '/order-status',
  '/teleclinic-confirmation',
  '/partner-confirmation',
  '/signup',
  '/registration/confirm',
  '/manage-booking',
  '/checkout',
  '/check-result',
  '/password-recovery',
  '/password-reset',
]

export const jwtQueryMiddleware: Middleware = () => (next) => async (action) => {
  if (isRejectedWithValue(action)) {
    if (401 === action.payload.status /*|| 403 === action.payload.status*/) {
      removeToken()

      const publicPageIndex = publicPages.findIndex((page) => location.pathname.includes(page), location.pathname)
      if (-1 === publicPageIndex) {
        window.location.href = '/login'
      }
    }

    return next(action)
  }

  return next(action)
}
